export default __webpack_public_path__ + "static/media/notif_mention_comment.2f7bb5c5.svg";